import {
    Avatar,
    Box,
    Button,
    Card,
    CardHeader,
    Chip,
    Grid,
    IconButton,
    InputBase,
    ListItemIcon,
    ListItemText,
    Pagination,
    Paper,
    Stack,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTheme } from '@mui/styles';
import SubCard from 'ui-component/cards/SubCard';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StyledDataGrid from 'ui-component/StyledDataGrid';
import axios from 'axios';
import ApiLink from 'API';
import { useNavigate } from 'react-router';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import ReactMoment from 'react-moment';
import CoinAoneDark200 from '../../../assets/images/CoinAoneDark200.png';
import CoinSamsungDark200 from '../../../assets/images/CoinSamsungDark200.png';
import DescriptionIcon from '@mui/icons-material/Description';
import { exportToCSV } from 'ui-component/exportToCSV';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { StyledMenu, StyledMenuItem } from 'ui-component/MenuPopup';
import SimpleBackdrop from 'ui-component/SimpleBackdrop';
import MessageBox from 'ui-component/MessageBox';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ViewInoice from 'views/invoice/ViewInoice';
import SearchField from 'ui-component/SearchField';
export const Receipt = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleCloseMore = () => {
        setAnchorEl(null);
    };
    const [openBackdrop, setopenBackdrop] = useState(false);
    const theme = useTheme();
    const [BillData, setBillData] = useState([]);
    const [totalPage, settotalPage] = useState(0);
    const [page, setpage] = useState(1);
    const [total, settotal] = useState(0);
    const navigate = useNavigate();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const [ValueSearch, setValueSearch] = useState('');
    const [OpenInvoice, setOpenInvoice] = useState(false);
    const [SelectedData, setSelectedData] = useState({});
    const [DataInvoice, setDataInvoice] = useState({});
    const handlePage = (event, value) => {
        setpage(value);
    };
    async function AcceptData(InvoiceID) {
        // console.log(DataImport.length);

        setopenBackdrop(true);
        await axios
            .post(
                ApiLink + '/api/stockcustomer/import/' + InvoiceID,
                {},
                {
                    withCredentials: true,
                    headers: {
                        token: localStorage.getItem('token')
                    }
                }
            )
            .then((res) => {
                LoadData(ValueSearch);
                // console.log(res.data);
                // setAlertBox({ open: true, message: 'Import successfully ReceiptID: ' + res.data.Receipt, severity: 'success' });
            })
            .catch((error) => {
                try {
                    if (error.response.status === 400 || error.response.status === 500) {
                        MessageBox.open({
                            title: 'Error',
                            content: <p>{error.response.data.msg}</p>,
                            buttons: [{ name: 'OK', handler: () => true }]
                        });
                        // setAlertBox({ open: true, message: error.response.data.msg, severity: 'error' });
                    } else if (error.response.status === 401 || error.response.status === 403) {
                        MessageBox.open({
                            title: 'Error',
                            content: <p>{error.response.data.errors[0].detail}</p>,
                            buttons: [{ name: 'OK', handler: () => true }]
                        });
                        //got to login and clear token
                        // localStorage.clear();
                        // navigate(0);
                    } else {
                        MessageBox.open({
                            title: 'Error',
                            content: <p>{error.response.statusText}</p>,
                            buttons: [{ name: 'OK', handler: () => true }]
                        });
                        // setAlertBox({ open: true, message: error.response.statusText, severity: 'error' });
                        // console.log(error.response.statusText);
                    }
                } catch (error) {
                    // setAlertBox({ open: true, message: error, severity: 'error' });
                    setopenBackdrop(false);
                }
            });

        setopenBackdrop(false);
    }
    const columns = [
        // { field: '_id', headerName: 'id', width: 90 },
        {
            field: 'customerStock',
            headerName: 'Status',
            width: 115,
            cellClassName: '',
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                if (params.row.customerStock === 0) {
                    return <Chip variant="outlined" color="success" icon={<CheckCircleOutlineIcon />} label="Accepted" />;
                } else {
                    return (
                        <Button
                            onClick={async () => {
                                const result = await MessageBox.open({
                                    title: 'Do you want to accept this invoice ?',
                                    content: (
                                        <Stack direction="column" alignContent="center" spacing={3}>
                                            <Stack direction="row" spacing={1}>
                                                <WarningAmberIcon color="primary" />
                                                <Typography variant="body1" noWrap>
                                                    After you accept. the product will automatic to your stock
                                                </Typography>
                                            </Stack>
                                            <Typography variant="body2" noWrap>
                                                Total: {params.row.stockController.length}
                                            </Typography>
                                        </Stack>
                                    ),
                                    buttons: [
                                        { name: 'Accept', handler: () => true },
                                        { name: 'Cancel', handler: () => false }
                                    ]
                                });
                                if (result) {
                                    AcceptData(params.row.invoiceNumber);
                                }
                            }}
                            variant="outlined"
                            endIcon={<CheckCircleOutlineIcon />}
                        >
                            Accept
                        </Button>
                    );
                }
            }
        },
        {
            field: 'invoiceNumber',
            headerName: 'Invoice Number',
            width: 200,
            sortable: false,
            filterable: false,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Typography
                    variant="button"
                    gutterBottom
                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '0.8rem' }}
                >
                    {params.row.invoiceNumber}
                </Typography>
            )
        },
        // {
        //     field: 'wallet',
        //     headerName: 'Wallet Payment',
        //     width: 150,
        //     // flex: 0.5,
        //     // editable: true,
        //     sortable: false,
        //     filterable: false,
        //     headerAlign: 'center',
        //     align: 'center',
        //     renderCell: (params) => (
        //         <Stack>
        //             <Button
        //                 fullWidth
        //                 startIcon={
        //                     <Avatar alt="Aone Coin" src={CoinAoneDark200} sx={{ width: 20, height: 20, background: 'transparent' }} />
        //                 }
        //             >
        //                 <Typography
        //                     variant="subtitle1"
        //                     sx={{
        //                         color: '#3035BC',
        //                         fontSize: '0.8rem'
        //                     }}
        //                 >
        //                     <NumberFormat
        //                         thousandsGroupStyle="thousand"
        //                         value={params.row.aonewallets !== null ? params.row.aonewallets.totalPayment : 0}
        //                         prefix="₭"
        //                         decimalSeparator="."
        //                         displayType="text"
        //                         type="text"
        //                         thousandSeparator={true}
        //                         allowNegative={true}
        //                     />
        //                 </Typography>
        //             </Button>
        //             <Button
        //                 fullWidth
        //                 startIcon={
        //                     <Avatar alt="Aone Coin" src={CoinSamsungDark200} sx={{ width: 20, height: 20, background: 'transparent' }} />
        //                 }
        //             >
        //                 <Typography
        //                     variant="subtitle1"
        //                     sx={{
        //                         color: '#000',
        //                         fontSize: '0.8rem'
        //                     }}
        //                 >
        //                     <NumberFormat
        //                         thousandsGroupStyle="thousand"
        //                         value={0}
        //                         prefix="₭"
        //                         decimalSeparator="."
        //                         displayType="text"
        //                         type="text"
        //                         thousandSeparator={true}
        //                         allowNegative={true}
        //                     />
        //                 </Typography>
        //             </Button>
        //         </Stack>
        //     )
        // },
        {
            field: 'totalPayment',
            headerName: 'Total',
            width: 120,
            sortable: false,
            filterable: false,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Typography
                    variant="body1"
                    color="#f57224"
                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '0.8rem' }}
                >
                    <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={params.row.totalPayment}
                        prefix="₭"
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        allowNegative={true}
                    />
                </Typography>
            )
        },
        {
            field: 'Amount',
            headerName: 'Amount',
            width: 120,
            sortable: false,
            filterable: false,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Typography
                    variant="button"
                    gutterBottom
                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '0.8rem' }}
                >
                    {params.row.stockController.length}
                </Typography>
            )
        },
        {
            field: 'createdAt',
            headerName: 'Date',
            width: 200,
            sortable: false,
            filterable: false,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            // editable: true,
            renderCell: (params) => {
                return (
                    <Typography
                        variant="button"
                        gutterBottom
                        style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '0.8rem' }}
                    >
                        {moment(params.row.createdAt).format('DD-MM-yyyy HH:mm')}
                    </Typography>
                );
            }
        },
        // {
        //     field: 'saleBy',
        //     headerName: 'SaleBy',
        //     width: 200,
        //     // flex: 0.5,
        //     // editable: true,
        //     headerAlign: 'center',
        //     align: 'center',
        //     renderCell: (params) => (
        //         <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
        //             {params.row.saleBy}
        //         </Typography>
        //     )
        // },
        {
            field: 'action',
            headerName: 'Action',
            // flex: 0.5,
            width: 80,
            sortable: false,
            filterable: false,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                // <Stack direction="row" spacing={1}>
                //     <IconButton
                //         // color="primary"
                //         sx={{ color: '#0c4da2' }}
                //         onClick={() => {
                //             setSelectedData(params.row);
                //             setOpenInvoice(true);
                //         }}
                //     >
                //         <VisibilityIcon />
                //     </IconButton>
                //     <IconButton
                //         variant="contained"
                //         color="success"
                //         onClick={(e) => {
                //             // console.log(params.row);
                //             exportToCSV(params.row.stockController, params.row.invoiceNumber);
                //         }}
                //     >
                //         <DescriptionIcon />
                //     </IconButton>
                // </Stack>
                <Stack direction="row" spacing={1}>
                    <IconButton
                        size="medium"
                        aria-controls="customized-menu"
                        aria-haspopup="true"
                        component="span"
                        style={{ marginLeft: 1 }}
                        onClick={(e) => {
                            setAnchorEl(e.currentTarget);
                            console.log(params.row);
                            setSelectedData(params.row);
                        }}
                    >
                        {/* {params.getValue("ref")} */}
                        <MoreVertIcon />
                    </IconButton>
                    <strong>
                        <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleCloseMore}>
                            <StyledMenuItem
                                onClick={() => {
                                    handleCloseMore();
                                    // setOpenInvoice(true);
                                    console.log(SelectedData.invoiceNumber);
                                    PreviewInvoice(SelectedData.invoiceNumber);
                                }}
                            >
                                <ListItemIcon>
                                    <VisibilityIcon variant="contained" sx={{ color: '#0c4da2' }} fontSize="default" />
                                </ListItemIcon>
                                <ListItemText primary="View Invoice" />
                            </StyledMenuItem>
                            <StyledMenuItem
                                onClick={() => {
                                    handleCloseMore();
                                    ExportExcel(SelectedData.invoiceNumber);
                                    // exportToCSV(SelectedData.stockController, params.row.invoiceNumber);
                                }}
                            >
                                <ListItemIcon>
                                    <DescriptionIcon variant="contained" color="success" fontSize="default" />
                                </ListItemIcon>
                                <ListItemText primary="Export IMEI" />
                            </StyledMenuItem>
                        </StyledMenu>
                    </strong>
                </Stack>
            )
            // editable: true
        }
    ];

    const ExportExcel = async (Requestid) => {
        try {
            setopenBackdrop(true);
            const Preview = await axios.get(ApiLink + '/api/stockcustomer/invoice/' + Requestid, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (Preview.status === 200) {
                exportToCSV(Preview.data?.data?.stockController, Requestid);
                // setDataInvoice(Preview.data?.data);
                // setOpenInvoice(true);
                // console.log(Preview.data.data);
                // const Content = await (<InvoicePDF data={Preview.data?.data} />);
                // MessageBox.open({
                //     title: 'Preview',
                //     content: Content,
                //     buttons: [{ name: 'Close', handler: () => true }]
                // });
            } else if (Preview.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
            console.log(error);
        }
        setopenBackdrop(false);
    };
    const PreviewInvoice = async (Requestid) => {
        try {
            setopenBackdrop(true);
            const Preview = await axios.get(ApiLink + '/api/stockcustomer/invoice/' + Requestid, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (Preview.status === 200) {
                setDataInvoice(Preview.data?.data);
                setOpenInvoice(true);
                // console.log(Preview.data.data);
                // const Content = await (<InvoicePDF data={Preview.data?.data} />);
                // MessageBox.open({
                //     title: 'Preview',
                //     content: Content,
                //     buttons: [{ name: 'Close', handler: () => true }]
                // });
            } else if (Preview.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
            console.log(error);
        }
        setopenBackdrop(false);
    };
    async function LoadData(ValueFind) {
        try {
            setBillData([]);
            setopenBackdrop(true);
            const valueReplate = ValueFind === '' ? '^' : ValueFind.toLowerCase();

            const response = await axios.get(ApiLink + '/api/stockcustomer/receipt/withoutdetail/' + valueReplate + '/' + page, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (response.status === 200) {
                setBillData(response.data.data);
                settotal(response.data.total);
                settotalPage(response.data.totalPage);
                setopenBackdrop(false);
            } else if (response.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            console.log(error);

            // localStorage.clear();
            // navigate(0);
        }
    }
    useEffect(() => {
        LoadData(ValueSearch);
    }, []);
    useEffect(() => {
        LoadData(ValueSearch);
    }, [page]);
    return (
        <>
            <ViewInoice Open={OpenInvoice} setOpen={setOpenInvoice} DataInvoice={DataInvoice} />
            {/* <ViewInoice Open={OpenInvoice} setOpen={setOpenInvoice} DataInvoice={SelectedData} /> */}
            <SimpleBackdrop open={openBackdrop} />
            <div id="app-message-box" />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SubCard
                        title="Invoice List"
                        contentSX={{ p: 0 }}
                        show={true}
                        secondary={
                            <SearchField
                                value={ValueSearch}
                                onChange={setValueSearch}
                                onSearch={(v) => { setpage(1); LoadData(v); }}
                                onReset={() => { setpage(1); LoadData(''); }}
                                placeholder="Invoice Number"
                                disabled={openBackdrop}
                                width={matchDownSM ? 180 : 300}
                            />
                        }
                    >
                        <Box
                            // style={{
                            //     width: '100%',
                            //     height: '80vh',
                            //     textAlign: 'center'
                            //     // overflow: "auto",
                            // }}
                            sx={{ width: '100%', height: '80vh', textAlign: 'center', border: 0, borderRadius: 16 }}
                        >
                            <StyledDataGrid
                                loading={openBackdrop}
                                getRowId={(row) => row._id}
                                rows={BillData}
                                columns={columns}
                                //pageSize={20}
                                rowHeight={100}
                                headerHeight={60}
                                hideFooter={true}
                            />
                        </Box>
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                paddingTop: '5px'
                            }}
                        >
                            <Pagination
                                disabled={openBackdrop}
                                count={totalPage}
                                // variant="outlined"
                                page={page}
                                size="small"
                                shape="rounded"
                                color="primary"
                                onChange={handlePage}
                                showFirstButton
                                showLastButton
                            />
                        </Box>
                        <p
                            style={{
                                fontSize: '10px',
                                display: 'flex',
                                justifyContent: 'center',
                                paddingTop: '5px'
                            }}
                        >
                            Total : {total}
                        </p>
                    </SubCard>
                </Grid>
            </Grid>
        </>
    );
};
